/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneIcon24Regular = forwardRef('SendPaperplaneIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.307 4.634c-.276-1.425 1.202-2.547 2.5-1.898l15.397 7.699c1.29.645 1.29 2.485 0 3.13L5.807 21.264c-1.298.649-2.776-.473-2.5-1.898L4.732 12 3.307 4.634Zm2.808 8.116-1.336 6.9a.25.25 0 0 0 .358.272l15.396-7.698a.25.25 0 0 0 0-.447L5.137 4.078a.25.25 0 0 0-.358.271l1.336 6.901h5.51a.75.75 0 1 1 0 1.5h-5.51Z" })));
});
